<template>
    <div id="book-result">
        <div class="wrapper">
            <div class="title">
                <h1>여기는 도록 신청자 목록입니다.</h1>
            </div>
            <div class="table">
                <table>
                    <tr>
                        <th class="number">번호</th>
                        <th class="name">이름</th>
                        <th class="addr">주소</th>
                        <th class="tel">연락처</th>
                    </tr>
                    <tr v-for="(item, i) in allApplicant" :key="i">
                        <td class="number">{{i + 1}}</td>
                        <td class="name">{{item.uploadData.name}}</td>
                        <td class="addr">{{item.uploadData.addr}}</td>
                        <td class="tel">{{item.uploadData.tel}}</td>
                    </tr>
                </table>
                <p class="tip">신청자 끝.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed:{
            allApplicant() { return this.$store.getters.allApplicant }
        },
        mounted() {
            this.$store.commit('loadAllApplicant')
        }
    }
</script>

<style scoped>
@media all and (max-width: 767px) {
    #book-result {
        width: 96vw;
        margin: 120px auto;
    }

    /* 타이틀 */
    #book-result .title {
        width: 96vw;
        font-size: 1.4rem;
    }

    /* 표 */
    #book-result .table {
        width: 92vw;
        margin: 56px auto;
    }
    #book-result .table table {
        width: 92vw;
        text-align: center;
    }
    #book-result .table table tr {
        border: 1px solid #ed86a1;
    }
    #book-result .table table tr th, #book-result .table table tr td {
        border: 1px solid #ed86a1;
        padding: 8px 0;
        font-size: 1rem;
        overflow: hidden;
        vertical-align: middle;
    }
    #book-result .table table tr th {
        font-size: 1rem;
    }
    .number {
        width: 5%;
    }
    .name {
        width: 8%;
    }
    .addr {
        width: 70%;
    }
    .tel {
        width: 18%;
    }
    .tip {
        margin: 48px 0;
    }
}
@media all and (min-width: 768px) {
    #book-result {
        width: 96vw;
        margin: 120px auto;
    }

    /* 타이틀 */
    #book-result .title {
        width: 96vw;
        font-size: 1.4rem;
    }

    /* 표 */
    #book-result .table {
        width: 92vw;
        margin: 56px auto;
    }
    #book-result .table table {
        width: 92vw;
        text-align: center;
    }
    #book-result .table table tr {
        border: 1px solid #ed86a1;
    }
    #book-result .table table tr th, #book-result .table table tr td {
        border: 1px solid #ed86a1;
        padding: 8px 0;
        font-size: 1.3rem;
        overflow: hidden;
    }
    #book-result .table table tr th {
        font-size: 1.3rem;
    }
    .number {
        width: 5%;
    }
    .name {
        width: 8%;
    }
    .addr {
        width: 70%;
    }
    .tel {
        width: 18%;
    }


    .tip {
        margin: 48px 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/BookResult.vue